import { addMonths as dateFnsAddMonths, differenceInDays, parseISO } from 'date-fns';

export const RENEWAL_WARNING_DAYS = 30;

export type SubscriptionStatus = 'ok' | 'warning' | 'expired';

export function getSubscriptionStatus(next_renewal_date: string): SubscriptionStatus {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const renewal = parseISO(next_renewal_date);
    const daysUntilRenewal = differenceInDays(renewal, today);

    if (daysUntilRenewal < 0) return 'expired';
    if (daysUntilRenewal <= RENEWAL_WARNING_DAYS) return 'warning';
    return 'ok';
}

export function getDaysUntilRenewal(next_renewal_date: string): number {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return differenceInDays(parseISO(next_renewal_date), today);
}

export function addMonths(date: Date, months: number): Date {
    return dateFnsAddMonths(date, months);
}

export function formatCurrency(amount: number): string {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(amount);
}
